export const customStyles = {
   rows: {
      style: {
         whiteSpace: "pre-line",
         borderBottom: "none !important",
         backgroundColor: "#F6F7F8",
         height: "54px"
      },

      stripedStyle: {
         // color: "NORMALCOLOR",
         backgroundColor: "#fff"
      }
   },
   headRow: {
      style: {
         borderBottom: "none !important"
      }
   },
   headCells: {
      style: {
         justifyContent: "flex-start",
         color: "#A4ABB7",
         fontFamily: "Gilroy",
         fontSize: "14px",
         fontStyle: "normal",
         fontWeight: 500,
         lineHeight: "normal",
         whiteSpace: "pre-line",
         backgroundColor: "#f9fafb",
         textTransform: "uppercase",
         padding: "0 10px",
         borderBottom: "none",
         background: "#FFF"
         // marginLeft: "6px"
      }
   },
   cells: {
      style: {
         justifyContent: "flex-start",
         padding: "0 10px",
         fontSize: "14px",
         lineHeight: "18px",
         letterSpacing: "1px",
         fontFamily: "Space Grotesk",
         fontStyle: "normal",
         fontWeight: "400",
         borderBottom: "none",
         // marginLeft: "6px",
         // paddingLeft: "10px",
         width: "fit-content",
         // alignItems: "left",
         // lineHeight: '21px',
         color: "#1B222B"
      }
   }
}
